import { SearchButton } from "../buttons";

export const lpMainSearchFormStyles = {
  mainSearchForm: {
    borderRadius: "0px",
  },
  searchBtn: {
    SearchButton,
  },
  inputGroupField: {
    paxBtn: {
      borderRadius: "0px",
    },
    inputGroup: {
      "& input": {
        borderRadius: "0px",
      },
      "& .css-pmvtch-control": {
        borderRadius: "0px",
      },
    },
  },
};
